export const env = {
    mode: process.env.NODE_ENV,
    videosdk: {
        token: process.env.VIDEOSDK_TOKEN ?? '',
    },
    geonames: {
        api: process.env.GEONAME_API ?? '',
        username: process.env.GEONAME_USERNAME ?? '',
    },
    rollback: {
        token: process.env.ROLL_BACK_TOKEN ?? '',
    },
    sentry: {
        dsn: process.env.SENTRY_DSN ?? '',
    },
};
